'use client';

import { cn } from '@/lib/utils';
import { memo, PropsWithChildren, ReactNode } from 'react';
import {
    Card,
    CardContent,
    CardDescription,
    CardFooter,
    CardHeader,
    CardTitle,
} from '../ui/card';

type CardContainerProps = {
    title?: ReactNode;
    classNameTitle?: string;

    description?: ReactNode;

    footer?: ReactNode;

    wrapperClassName?: string;

    contentClassName?: string;

    /**Ẩn đi content nhưng smooth */
    contentHidden?: boolean;
};

const CardContainer = (props: PropsWithChildren<CardContainerProps>) => {
    const {
        title,
        classNameTitle,
        description,
        footer,
        wrapperClassName,
        contentClassName,
        contentHidden = false,
        children,
    } = props;

    const hvHeader = !!(title || description);
    const hvFooter = !!footer;

    return (
        <Card
            className={cn('mb-2 max-w-full', wrapperClassName)}
            suppressHydrationWarning
        >
            {hvHeader && (
                <CardHeader className={cn('p-4 lg:p-6', classNameTitle)}>
                    {typeof title === 'string' ? (
                        <CardTitle className='text-primary'>{title}</CardTitle>
                    ) : (
                        <div
                            className={cn(
                                'text-2xl font-semibold leading-none tracking-tight text-primary'
                            )}
                        >
                            {title}
                        </div>
                    )}
                    {description && (
                        <CardDescription>{description}</CardDescription>
                    )}
                </CardHeader>
            )}

            <CardContent
                aria-hidden={contentHidden}
                className={cn(
                    'p-4 lg:p-6',
                    {
                        hidden: contentHidden,
                        'pt-0 lg:pt-0': hvHeader,
                    },
                    // contentClassName ? { [contentClassName]: !hvHeader } : {}

                    contentClassName
                )}
            >
                {children}
            </CardContent>

            {hvFooter && (
                <CardFooter className='p-4 lg:p-6'>{footer}</CardFooter>
            )}
        </Card>
    );
};

export default memo(CardContainer);
